import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import { HiPlusCircle, HiPencilAlt, HiOutlineTrash, HiOutlineCheck, HiOutlineXCircle } from "react-icons/hi";
import {
  useReactTable,
  getCoreRowModel
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState, setState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../../src/General/General';
import DatePicker from "react-multi-date-picker";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
const ContentInfo = () => {
    //#region const
    const navigate = useNavigate();
    const [Configs, setConfigs] = useState([]);
    const [Mobile, setMobile] = useState("");
    const [SecondMobile, setSecondMobile] = useState("");
    const [Tel, setTel] = useState("");
    const [MobileIsActive, setMobileIsActive] = useState(false);
    const [SecondMobileIsActive, setSecondMobileIsActive] = useState(false);
    const [TelIsActive, setTelIsActive] = useState(false);
    const [Email, setEmail] = useState("");
    const [Address, setAddress] = useState("");
    const [Id, setId] = useState(General.GuidEmpty());
    const [ErrorMsg, setErrorMsg] = useState("");
    const toaster = useToaster();
    //#endregion
    //#reggion method
    const CheckValidation = () => {
        let tmp = [...Configs];
        for (let i = 0; i < Configs.length; i++) {
            if (Configs[i].Key === "Mobile") {
                tmp[i].Value = Mobile;
                tmp[i].IsActive = MobileIsActive;
            } else if (Configs[i].Key === "SecondMobile") {
                tmp[i].Value = SecondMobile;
                tmp[i].IsActive = SecondMobileIsActive;
            } else if (Configs[i].Key === "Tel") {
                tmp[i].Value = Tel;
                tmp[i].IsActive = TelIsActive;
            } else if (Configs[i].Key === "Email") {
                tmp[i].Value = Email;
            } else if (Configs[i].Key === "Address") {
                tmp[i].Value = Address;
            }
        }
        setConfigs(tmp);
    
        if (!MobileIsActive && !SecondMobileIsActive) {
            setErrorMsg('حداقل یکی از شماره موبایل ها باید فعال باشد');
            toaster.push(General.ShowMessage('error', 'حداقل یکی از شماره موبایل ها باید فعال باشد'), 'topCenter');
            return false;
        } else if (Mobile === "" && MobileIsActive) {
            setErrorMsg('شماره موبایل اول را وارد کنید');
            toaster.push(General.ShowMessage('error', 'شماره موبایل اول را وارد کنید'), 'topCenter');
            return false;
        } else if (SecondMobile === "" && SecondMobileIsActive) {
            setErrorMsg('شماره موبایل دوم را وارد کنید');
            toaster.push(General.ShowMessage('error', 'شماره موبایل دوم را وارد کنید'), 'topCenter');
            return false;
        } else if (TelIsActive && Tel === "") {
            setErrorMsg('تلفن را وارد کنید');
            toaster.push(General.ShowMessage('error', 'تلفن را وارد کنید'), 'topCenter');
            return false;
        } else if (Address === "") {
            setErrorMsg('آدرس را وارد کنید');
            toaster.push(General.ShowMessage('error', 'آدرس را وارد کنید'), 'topCenter');
            return false;
        } else if (Email === "") {
            setErrorMsg('ایمیل را وارد کنید');
            toaster.push(General.ShowMessage('error', 'ایمیل را وارد کنید'), 'topCenter');
            return false;
        }
        return true;
    };

    const Save = () => {
        const isValid = CheckValidation();
        if (isValid) {
            setErrorMsg("");
            const requestOptions = {
                url: General.ApiRoot() + '/configs/update',
                method: "post",
                data: Configs,
                headers: {
                    'Content-Type': 'application/json',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(function (result) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفقیت انجام شد'), 'topCenter');
                    })
                    .catch((error) => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    };

    const GetInfo = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/configs/getAll',
            method: "get",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setConfigs(result.data);
                    result.data.forEach(config => {
                        if (config.Key === "Email") {
                            setEmail(config.Value);
                        }
                        if (config.Key === "Mobile") {
                            setMobile(config.Value);
                            setMobileIsActive(config.IsActive);
                        }
                        if (config.Key === "SecondMobile") {
                            setSecondMobile(config.Value);
                            setSecondMobileIsActive(config.IsActive);
                        }
                        if (config.Key === "Tel") {
                            setTel(config.Value);
                            setTelIsActive(config.IsActive);
                        }
                        if (config.Key === "Address") {
                            setAddress(config.Value);
                        }
                    });
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    //#endregion
    useEffect(() => {
        // Check if the user is authenticated
        if (!General.isLoggedIn()) {
            navigate('/'); // Redirect to login if not authenticated
        }
        else {
            GetInfo();
        }
    }, []);

    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <rsuite.Grid fluid className="h-[20%] sm:h-[13%] pb-5">
                    <rsuite.Row className="bg-gray-100 m-2 rounded-lg h-1/2 sm:h-full flex items-center px-1 sm:px-5">
                        <rsuite.Col xs={12}>
                            <p>اطلاعات</p>
                        </rsuite.Col>
                    </rsuite.Row>

                    <rsuite.Row className="bg-gray-100 m-2 rounded-lg h-1/2 flex items-center px-1 sm:hidden">
                        <rsuite.Col xs={24} className="flex justify-end items-end">
                            <rsuite.Button color="cyan" appearance="primary" size="lg">
                                <HiPlusCircle className="me-3" />
                                جدید
                            </rsuite.Button>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Grid>

                <div className="w-full h-[85%] relative">
                    <rsuite.Panel className="bg-gray-100 rounded-lg w-full h-full">
                        <rsuite.Row>
                            <rsuite.Col xs={24} md={6}>
                                <label>
                                    شماره موبایل اول
                                </label>
                                <rsuite.Input
                                    className="mt-2"
                                    value={Mobile}
                                    onChange={(e) => setMobile(e)}
                                >
                                </rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={6} className="md:mt-5">
                                <rsuite.Checkbox checked={MobileIsActive} onChange={() => setMobileIsActive(!MobileIsActive)}>فعال می‌باشد</rsuite.Checkbox>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={6}>
                                <label>
                                    شماره موبایل دوم
                                </label>
                                <rsuite.Input
                                    className="mt-2"
                                    value={SecondMobile}
                                    onChange={(e) => setSecondMobile(e)}
                                >
                                </rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={6} className="md:mt-5">
                                <rsuite.Checkbox checked={SecondMobileIsActive} onChange={() => setSecondMobileIsActive(!SecondMobileIsActive)}>فعال می‌باشد</rsuite.Checkbox>
                            </rsuite.Col>
                        </rsuite.Row>
                        <rsuite.Divider />
                        <rsuite.Row className="mt-3">
                            <rsuite.Col xs={24} md={12}>
                                <label>
                                    ایمیل
                                </label>
                                <rsuite.Input
                                    className="mt-2"
                                    value={Email}
                                    onChange={(e) => setEmail(e)}
                                >
                                </rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={6}>
                                <label>
                                    تلفن ثابت
                                </label>
                                <rsuite.Input
                                    className="mt-2"
                                    value={Tel}
                                    onChange={(e) => setTel(e)}
                                >
                                </rsuite.Input>
                            </rsuite.Col>
                            <rsuite.Col xs={24} md={6} className="md:mt-5">
                                <rsuite.Checkbox checked={TelIsActive} onChange={() => setTelIsActive(!TelIsActive)}>فعال می‌باشد</rsuite.Checkbox>
                            </rsuite.Col>
                        </rsuite.Row>
                        <rsuite.Divider />
                        <rsuite.Row className="mt-3">
                            <rsuite.Col xs={24}>
                                <label>
                                    آدرس
                                </label>
                                <rsuite.Input
                                    as="textarea"
                                    className="mt-2"
                                    value={Address}
                                    onChange={(e) => setAddress(e)}
                                >
                                </rsuite.Input>
                            </rsuite.Col>
                        </rsuite.Row>
                        <div class="absolute bottom-0 left-0 m-5">
                            <rsuite.Button
                                appearance="primary"
                                className="absolute bottom-0 left-0"
                                color="green"
                                onClick={() => Save()}
                                startIcon={<HiOutlineCheck className="me-2" />}>
                                ذخیره
                            </rsuite.Button>
                        </div>
                    </rsuite.Panel>

                </div>
            </div>
        </SharedLayouts>
    )
}
export default ContentInfo;